var $;
// wait for jQuery
function waitForjQuery(trigger) {
  var interval = setInterval(function () {
    if (window.jQuery !== undefined) {
      clearInterval(interval);
      trigger(window.jQuery);
    }
  }, 50);
  setTimeout(function () {
    clearInterval(interval);
  }, 25000);
}

// Wait for date picker
function waitForDatePicker(trigger) {
  var interval = setInterval(function () {
    if ($.datepicker !== undefined) {
      clearInterval(interval);
      trigger(window.jQuery);
    }
  }, 50);
  setTimeout(function () {
    clearInterval(interval);
  }, 25000);
}

waitForjQuery(function () {
  var childNameVal = "";
  $ = window.jQuery;

  // Email validation
  function validateEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
  }
  // Validate Text length
  function validateTextLength(inputText) {
    if (inputText.length > 0) {
      return true;
    }
    return false;
  }

  // Loading progres form
  function loadingProgressForm() {
    $(".form-header,#progress-form .shopify-section:first").show();
    $(".quiz-start-button").closest(".shopify-section").slideUp();
  }

  // Load progress step
  function loadProgressStep() {
    // alert(window.location.href);
    const windowUrl = window.location.href.split("?step=")[1];

    if (!windowUrl) {
      return false;
    }
    if (windowUrl == 1) {
      loadingProgressForm();
    }
    if (windowUrl > 1) {
      $(
        ".form-header,#progress-form #shopify-section-quiz-" + windowUrl
      ).show();
      $(".quiz-start-button").closest(".shopify-section").slideUp();
    }
  }
  loadProgressStep();

  // Insert error text
  function appendErrorText(_this, inputType) {
    if (inputType == "text" && _this.find("p.errorMsg").length == 0) {
      _this
        .addClass("hasErrorText")
        .append("<p class='errorMsg'>Please enter valid input.</p>");
    }
    if (inputType == "checkbox" && _this.find("p.errorMsg").length == 0) {
      _this
        .addClass("hasErrorText")
        .append("<p class='errorMsg'>Please select valid option.</p>");
    }
    if (inputType == "email" && _this.find("p.errorMsg").length == 0) {
      _this
        .addClass("hasErrorText")
        .append("<p class='errorMsg'>Please enter valid email address.</p>");
    }
  }
  function removeErrorText(_this) {
    _this.removeClass("hasErrorText").find(".errorMsg").remove();
  }

  // Update child name
  function childName() {
    $(".question").each(function () {
      var questionObj = $(this);
      if (questionObj.text().includes("{child’s name}")) {
        var childNameVal =
          $('input[name="page__2__question_1"]').val() || "{child's name}";
        var newQuestionText = questionObj
          .text()
          .replace(
            "{child’s name}",
            "<span class='child-name'>" + childNameVal + "</span>"
          );
        questionObj.html(newQuestionText);
      }
    });
  }
  childName();

  // History change event
  function historyChange(step) {
    var newurl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname +
      "?step=" +
      step;
    window.history.replaceState(
      {
        path: newurl,
      },
      "",
      newurl
    );
  }

  // initialize datepicker
  waitForDatePicker(function () {
    $(".datepicker").datepicker({
      dateFormat: "mm/dd/yy",
      changeMonth: true,
      changeYear: true,
    });
  });

  // Click on ans choice button
  $(
    ".answer-grid-style .choices__inner label, .answer-full-width-style .choices__inner label"
  ).on("click", function () {
    $(this).parent().toggleClass("active");
  });

  // click on quiz start button
  $(".quiz-start-button").on("click", function () {
    loadingProgressForm();
    historyChange(1);
  });

  // Click on back button
  $(".wizard-prev-btn, .btn-back").on("click", function () {
    $(this)
      .parents(".shopify-section")
      .prev()
      .slideDown("normal", function () {
        $("html, body").animate({ scrollTop: $("body").offset().top });
      });

    $(this).parents(".shopify-section").hide();
  });

  // Click on next step button
  $(".next-page-button").on("click", function () {
    var hasValidData = true;
    var buttonType = $(this).attr("class");
    $(this)
      .closest(".shopify-section")
      .find(".required-field")
      .each(function () {
        var inputType = $(this).find("input").attr("type");
        switch (inputType) {
          case "text":
            var inputValue = $(this).find("input").val();
            const textInputValidation = validateTextLength(inputValue);
            if (!textInputValidation) {
              hasValidData = false;
              appendErrorText($(this), inputType);
            } else {
              removeErrorText($(this));
            }
            break;
          case "email":
            var inputValue = $(this).find("input").val();
            const emailInputValidation = validateEmail(inputValue);
            if (!emailInputValidation) {
              hasValidData = false;
              appendErrorText($(this), inputType);
            } else {
              removeErrorText($(this));
            }
            break;
          case "checkbox":
            var checkBoxArray = [];
            var inputValue = $(this)
              .find("input:checked")
              .each(function () {
                if ($(this).val() == "") {
                  checkBoxArray.push(
                    $('input[name="page__1__question_4__other"]').val()
                  );
                } else {
                  checkBoxArray.push($(this).val());
                }
              });

            const cehcekBoxInputValidation = validateTextLength(
              checkBoxArray.toString()
            );
            if (!cehcekBoxInputValidation) {
              hasValidData = false;
              appendErrorText($(this), inputType);
            } else {
              removeErrorText($(this));
            }
            break;
        }
      });

    if (hasValidData && buttonType.indexOf("wizard-next-btn") > -1) {
      $(this).parents(".shopify-section").next().show();
      $(this)
        .parents(".shopify-section")
        .slideUp("normal", function () {
          $("html, body").animate({ scrollTop: $("body").offset().top });
        });
    }
    if (hasValidData && buttonType.indexOf("wizard-finish-btn") > -1) {
      $(".popup-lazyload-container").addClass("show");
      createRecordAirtable();
    }
  });

  // Click on color options
  $(".block-1.answer-grid-style .choices__inner[attr-color] label").on(
    "click",
    function () {
      var colorPicked = $(this).parent().attr("attr-color");

      if (
        !$(
          '.block-2.answer-grid-style .choices__inner[attr-color="' +
            colorPicked +
            '"]'
        ).hasClass("hidden")
      ) {
        $(
          '.block-2.answer-grid-style .choices__inner[attr-color="' +
            colorPicked +
            '"]'
        ).fadeOut();
        $(
          '.block-2.answer-grid-style .choices__inner[attr-color="' +
            colorPicked +
            '"]'
        ).addClass("hidden");
      } else {
        $(
          '.block-2.answer-grid-style .choices__inner[attr-color="' +
            colorPicked +
            '"]'
        ).toggle();
        $(
          '.block-2.answer-grid-style .choices__inner[attr-color="' +
            colorPicked +
            '"]'
        ).removeClass("hidden");
      }
    }
  );

  $(".container-chk-rdo").on("click", function () {
    var isChecked = $(this).find("input").is(":checked");

    if (isChecked) {
      $(this).addClass("active");
    } else {
      $(this).removeClass("active");
    }
  });

  $("#add-another-form").on("click", function () {
    $("#shopify-section-quiz-1").show();
    $("#shopify-section-quiz-6").slideUp();
    $("html, body").animate({ scrollTop: $("body").offset().top });
    $(".popup-lazyload-container").removeClass("show");
    $(".popup-container.blog-newsletter-popup").removeClass("show");
  });

  $("#done-with-form").on("click", function () {
    window.location.href = "/";
  });

  /**
   * Blur options
   *
   * 1- On child name input blur
   */
  $('input[name="page__2__question_1"]').on("blur", function () {
    childNameVal = $(this).val();
    $(".child-name").text(childNameVal);
    childName();
  });
  $('input[name="page__1__question_1"]').on("blur", function () {
    var quizerName = $(this).val();
    $(".quizer-name").text(quizerName);
  });

  // Make input and checkbox mandatory
  $(
    "#shopify-section-quiz-1 [class*='block-'], #shopify-section-quiz-2 .block-1,#shopify-section-quiz-2 .block-2, #shopify-section-quiz-3 .block-1,#shopify-section-quiz-3 .block-3, #shopify-section-quiz-4 .block-1, #shopify-section-quiz-5 .block-1, #shopify-section-quiz-5 .block-2, #shopify-section-quiz-6 .block-1,#shopify-section-quiz-6 .block-2,#shopify-section-quiz-6 .block-3"
  ).addClass("required-field");

  // Placetext for input
  $("#shopify-section-quiz-1 .block-1 input").attr("placeholder", "John");
  $("#shopify-section-quiz-1 .block-2 input").attr("placeholder", "Doe");
  $("#shopify-section-quiz-1 .block-3 input").attr(
    "placeholder",
    "johndoe@mail.com"
  );
  $("#shopify-section-quiz-2 .block-1 input").attr("placeholder", "John");
  $("#shopify-section-quiz-2 .block-2 input").attr("placeholder", "XX/XX/XXXX");
  $("#shopify-section-quiz-2 input[name='page__2__question_3_4']").attr(
    "placeholder",
    "Length or height"
  );
  $("#shopify-section-quiz-2 input[name='page__2__question_3_5']").attr(
    "placeholder",
    "Weight"
  );
  $("#shopify-section-quiz-3 .block-4 input").attr("placeholder", "Blue");
  $("#shopify-section-quiz-5 .block-3 input").attr("placeholder", "Jacket");
  $("#shopify-section-quiz-6 .block-2 input").attr("placeholder", "Text");
  $("#shopify-section-quiz-6 .block-4 input").attr("placeholder", "Text");

  /* Airtable */
  function createRecordAirtable() {
    var customerFirstName = $('input[name="page__1__question_1"]').val();
    var customerLastName = $('input[name="page__1__question_2"]').val();
    var customerEmailAddress = $('input[name="page__1__question_3"]').val();

    var mostExcitedAbout = [];
    $("input[name='page__1__question_4']:checked").each(function () {
      if ($(this).val() == "") {
        mostExcitedAbout.push(
          $('input[name="page__1__question_4__other"]').val()
        );
      } else {
        mostExcitedAbout.push($(this).val());
      }
    });

    var childFirstName = $('input[name="page__2__question_1"]').val();
    var childDOB = $('input[name="page__2__question_2"]').val();

    var childLength_Or_Height = $('input[name="page__2__question_3_4"]').val();
    var childWeight = $('input[name="page__2__question_3_5"]').val();

    var specificColorChildLike = [];
    $("input[name='page__3__question_1']:checked").each(function () {
      specificColorChildLike.push($(this).val());
    });

    var specificColorChildDontLike = [];
    $("input[name='page__3__question_2']:checked").each(function () {
      specificColorChildDontLike.push($(this).val());
    });

    var colorPalettesChildLike = [];
    $("textarea[name='page__3__question_3']").each(function () {
      colorPalettesChildLike.push($(this).val());
    });

    var otherSpecificColorChildDontLike = $(
      'input[name="page__3__question_4"]'
    ).val();

    var patternsYou_or_childLike = [];
    $("input[name='page__4__question_1']:checked").each(function () {
      patternsYou_or_childLike.push($(this).val());
    });

    var styleYou_or_childLike = [];
    $("input[name='page__5__question_1']:checked").each(function () {
      styleYou_or_childLike.push($(this).val());
    });
    var typeOfCloth = [];
    $("input[name='page__5__question_2']:checked").each(function () {
      typeOfCloth.push($(this).val());
    });

    var anythingElseNeeds = $("textarea[name='page__5__question_3']").val();

    var childFavoriteActivities = $("input[name='page__6__question_1']").val();

    var howYouDiscribeChildStyle = [];
    $("input[name='page__6__question_2']:checked").each(function () {
      howYouDiscribeChildStyle.push($(this).val());
    });

    var fromWherePreviouslyPurchased = [];
    $("textarea[name='page__6__question_3']").each(function () {
      if ($(this).val() == "") {
        fromWherePreviouslyPurchased.push(
          $('input[name="page__6__question_3__other"]').val()
        );
      } else {
        fromWherePreviouslyPurchased.push($(this).val());
      }
    });

    var anythingElseWhatToShare = $("input[name='page__6__question_4']").val();

    var answers = {
      records: [
        {
          fields: {
            "Question 1": customerFirstName,
            "Question 2": customerLastName,
            "Question 3": customerEmailAddress,
            "Question 4": mostExcitedAbout.toString(),
            "Question 5": childFirstName,
            "Question 6": childDOB,
            "Colors Like": specificColorChildLike.toString(),
            "Colors Avoid": specificColorChildDontLike.toString(),
            "Question 9": colorPalettesChildLike.toString(),
            "Question 10": otherSpecificColorChildDontLike,
            "Question 11": patternsYou_or_childLike.toString(),
            "Question 12": styleYou_or_childLike.toString(),
            "Question 13": typeOfCloth.toString(),
            "Question 14": anythingElseNeeds,
            "Question 15": childFavoriteActivities,
            "Question 16": howYouDiscribeChildStyle.toString(),
            "Question 17": fromWherePreviouslyPurchased.toString(),
            "Question 18": anythingElseWhatToShare,
            Customer_id: String(__st.cid || ""),
          },
        },
      ],
    };

    // "Question 1": customerFirstName,
    // "Question 2": customerLastName,
    // "Question 3": customerEmailAddress,
    // "Question 4": mostExcitedAbout.toString(),
    // "Question 5": childFirstName,
    // "Question 6": childDOB,
    // "Colors Like": specificColorChildLike.toString(),
    // "Colors Avoid": specificColorChildDontLike.toString(),
    // "Question 9": colorPalettesChildLike.toString(),
    // "Question 10": otherSpecificColorChildDontLike,
    // "Question 11": patternsYou_or_childLike.toString(),
    // "Question 12": styleYou_or_childLike.toString(),
    // "Question 13": typeOfCloth.toString(),
    // "Question 14": anythingElseNeeds,
    // "Question 15": childFavoriteActivities.toString(),
    // "Question 16": howYouDiscribeChildStyle,
    var questions = [];
    $(".question__container p.question").each(function () {
      questions.push($(this).text());
    });

    var klav_data = {
      question4: questions[3],
      question5: questions[4],
      question6: questions[5],
      question7: questions[6],
      question8: "Child's weight",
      question9: questions[7],
      question10: questions[8],
      question11: questions[9],
      question12: questions[10],
      question13: questions[11],
      question14: questions[12],
      question15: questions[13],
      question16: questions[14],
      question17: questions[15],
      question18: questions[16],
      question19: questions[17],
      question20: questions[18],
      question21: "Customer_id",
      first_name: customerFirstName,
      last_name: customerLastName,
      email: customerEmailAddress,
      answer4: mostExcitedAbout.toString(),
      answer5: childFirstName,
      answer6: childDOB,
      answer7: childLength_Or_Height,
      answer8: childWeight,
      answer9: specificColorChildLike.toString(),
      answer10: specificColorChildDontLike.toString(),
      answer11: colorPalettesChildLike.toString(),
      answer12: otherSpecificColorChildDontLike,
      answer13: patternsYou_or_childLike.toString(),
      answer14: styleYou_or_childLike.toString(),
      answer15: typeOfCloth.toString(),
      answer16: anythingElseNeeds,
      answer17: childFavoriteActivities,
      answer18: howYouDiscribeChildStyle.toString(),
      answer19: fromWherePreviouslyPurchased.toString(),
      answer20: anythingElseWhatToShare,
      answer21: String(__st.cid) || "Null",
    };

    // return false;

    var apiKey = "Bearer keyg1zCZnTX9BlLYj";
    var baseId = "appR4mXXHlRiRpkdX";
    var tablename = "Rent A Romper";
    var endpointUrl = "https://api.airtable.com/v0/" + baseId + "/" + tablename;

    $.ajax({
      contentType: "application/json",
      headers: {
        Authorization: apiKey,
      },
      method: "POST",
      data: JSON.stringify(answers),
      url: endpointUrl,
      beforeSend: function (xhr) {
        $(".popup-lazyload-container").addClass("show");
      },
    })
      .done(function (response) {
        var klaviyoListId = "VX4my4";
        $.ajax({
          contentType: "application/json",
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: JSON.stringify({ profiles: [klav_data] }),
          crossDomain: true,
          async: false,
          url: "https://wxppi0g8sl.execute-api.us-east-1.amazonaws.com/dev/?url=https://a.klaviyo.com/api/v2/list/TrmRP7/members",
          beforeSend: function (xhr) {
            $(".popup-lazyload-container").addClass("show");
          },
        });
        // prettier-ignore
        $.ajax({
            contentType: "application/json",
            method: "POST",
            headers: {
              "Accept": "application/json",
              "Content-Type": "application/json"
            },
            data: JSON.stringify(
              {
                "profiles": [
                  {
                    "email": customerEmailAddress,
                    'Tagged': "Style Quiz"
                  }
                ]
              }
            ),
            crossDomain: true,
            async: false,
            url: "https://wxppi0g8sl.execute-api.us-east-1.amazonaws.com/dev/?url=https://a.klaviyo.com/api/v2/list/" + klaviyoListId + "/members"
          }).done(function(response) {
            $('input[type="text"], input[type="email"], input[type="date"],textarea').val("");
            $("input[type='checkbox']:checked").each(function() {
              $(this).prop("checked", false);
            });
            $("input[type='radio']:checked").each(function() {
              $(this).prop("checked", false);
            });
            $(".container-chk-rdo").removeClass("active");
            $(".color-choices, .image-choices").removeClass("active");
            $(".child-name").text("");
            $(".quizer-name").text("");
            childNameVal = "";
  
            $(".popup-lazyload-container").removeClass("show");
            $(".popup-container.blog-newsletter-popup").addClass("show");

          }).catch(function (err) {
            $('input[type="text"], input[type="email"], input[type="date"],textarea').val("");
            $("input[type='checkbox']:checked").each(function() {
              $(this).prop("checked", false);
            });
            $("input[type='radio']:checked").each(function() {
              $(this).prop("checked", false);
            });
            $(".container-chk-rdo").removeClass("active");
            $(".color-choices, .image-choices").removeClass("active");
            $(".child-name").text("");
            $(".quizer-name").text("");
            childNameVal = "";
  
            $(".popup-lazyload-container").removeClass("show");
            $(".popup-container.blog-newsletter-popup").addClass("show");
            console.log(err)
            //window.alert(err?.message || "Something went wrong in Klaviyo");
          });
      })
      .catch(function (err) {
        console.log(err);
        $(".popup-lazyload-container").removeClass("show");
        //window.alert(err?.message || "Something went wrong in airtable");
      });
  }
});
